import * as React from "react";
import { Context } from "./_context";
export const HashIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M16.994 3.11 16.451 8H21.5v2h-5.271l-.445 4H20.5v2h-4.938l-.568 5.11-1.988-.22.543-4.89H9.562l-.568 5.11-1.988-.22.543-4.89H2.5v-2h5.271l.445-4H3.5V8h4.938l.568-5.11 1.988.22L10.451 8h3.987l.568-5.11 1.988.22ZM9.784 14h3.987l.445-4h-3.987l-.445 4Z", fill: "currentColor" }));
  return iconset[size];
};
HashIcon.iconId = "K1Vzpl";
